var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('report-template',{attrs:{"options":_vm.options,"chartOptions":_vm.chartOptions,"series":_vm.series,"selectTab":_vm.selectTab,"loadReport":_vm.fetchReport}})
}
var staticRenderFns = []

export { render, staticRenderFns }